import { useCallback } from 'react'

import { Ok } from 'ts-results'

import { useApi } from 'app/common/application'

import { ShopifyUpdateShopRequest, ShopifyUpdateShopResponse } from '../types'

const useShopifyConnectionApi = () => {
  const { create } = useApi()

  const updateShop = useCallback(
    async (shopName: string) => {
      const result = await create<ShopifyUpdateShopRequest, ShopifyUpdateShopResponse>(
        `/connections/shopify/updateShop`,
        { content: { shopName } },
      )
      if (result.ok) {
        const { _id: id, ...connEntity } = result.val.data
        return Ok({ ...connEntity, id })
      }

      return result
    },
    [create],
  )

  return {
    updateShop,
  }
}

export default useShopifyConnectionApi
